import { PrivacyNoticeBody } from './PrivacyNoticeBody';
import { usePrivacyNotice } from './usePrivacyNotice';
import { Modal } from '../ui/Modal';
import { Button } from '../ui/Button';
import { ErrorNotice } from '../ui/ErrorNotice';

/**
 * Die Hinweise im Dialog — aufrufbar aus dem Buchungsformular heraus.
 *
 * Bewusst kein Verweis auf eine andere Seite: Wer mitten im Ausfüllen weggeht,
 * kommt mit leerem Formular zurück. Ein Text, den zu lesen das Ausgefüllte
 * kostet, wird nicht gelesen.
 */
export function PrivacyNoticeModal({ onClose }: { onClose: () => void }) {
  const { data, isPending, isError, error } = usePrivacyNotice();

  return (
    <Modal
      title="Datenschutzhinweise"
      description="Was bei einer Fahrzeugbuchung gespeichert wird — und warum."
      onClose={onClose}
      size="lg"
    >
      {isPending && <p className="text-sm text-slate-500">Wird geladen …</p>}
      {isError && <ErrorNotice error={error} />}
      {data && <PrivacyNoticeBody notice={data} />}

      <div className="mt-6 flex justify-end border-t border-slate-200 pt-4">
        <Button onClick={onClose}>Schließen</Button>
      </div>
    </Modal>
  );
}
